import { Component , ViewContainerRef} from '@angular/core';

import { ToastsManager } from 'ng2-toastr/ng2-toastr';

import { UserService , IMessage} from './user.services';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'app';
  newUser = {
    name: '',
    email: '',
    subject: '',
  };

  message: IMessage = {};
  constructor (private userService: UserService,public toastr: ToastsManager, vcr: ViewContainerRef) {
    this.toastr.setRootViewContainerRef(vcr);
  }

  sendEmail(message: IMessage) {
    let isValid = /^[_a-z0-9]+(\.[_a-z0-9]+)*@[a-z0-9-]+(\.[a-z0-9-]+)*(\.[a-z]{2,4})$/.test(message.email);
    if(isValid){
        this.userService.sendEmail(message).subscribe(res => {
          this.message = {};
          this.showSuccess();
        }, error => {
          this.showError();
        });
    }else{
      this.showInvalidEmail();
    }
  }

    showSuccess() {
        this.toastr.success('Request Send Sucessfully', 'Success!');
    }

    showInvalidEmail() {
        this.toastr.error('Please enter valid email', 'Invalid!');
    }

    showError() {
        this.toastr.error('Request send failed', 'Server Error');
    }

}



// WEBPACK FOOTER //
// ./src/app/app.component.ts